import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractBaseFieldComponent } from '@shared/components/form-elements/abstract-field-base';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { provideNgxMask } from 'ngx-mask';
import { FormErrorsComponent } from '@shared/components/form-elements/form-errors/form-errors.component';

@Component({
  selector: 'cx-input-file',
  imports: [CommonModule, FormsModule, FormErrorsModule, FormErrorsComponent],
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  providers: [
    provideNgxMask(),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileComponent),
      multi: true,
    },
  ],
  host: {
    '[attr.id]': 'null',
  },
})
export class InputFileComponent extends AbstractBaseFieldComponent implements ControlValueAccessor {
  @Input() control?: AbstractControl | null;
  @Input() label = '';
  @Input() hintText = '';
  @Input() id = this.generateId();
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() valid?: boolean;
  @Input() invalid?: boolean;

  selectedFile: File | null = null;
  fileName: string = 'Nenhum arquivo escolhido';

  onChangeInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.selectedFile = file;
      this.fileName = file.name;

      const fileData = {
        name: file.name,
        type: file.type,
        size: file.size,
        lastModified: file.lastModified,
        lastModifiedDate: new Date(file.lastModified),
      };

      this.control?.setValue(fileData);
      this.onChange(fileData);
    } else {
      this.selectedFile = null;
      this.fileName = 'Nenhum arquivo escolhido';
      this.control?.setValue(null);
      this.onChange(null);
    }
  }

  onTouchedInput(): void {
    this.control?.markAsTouched();
    this.onTouched();
  }
}
